<goab-button
  type="tertiary"
  size="compact"
  variant="normal"
  leadingIcon="arrow-back"
  [attr.data-testid]="'help-back-button'"
  (onClick)="goBack()"
  mt="xs"
>
  Return to Capacity reports overview
</goab-button>
<goab-text
  [attr.data-testid]="'help-title'"
  size="heading-l"
  tag="h1"
  mt="2xl"
  mb="l"
>
  <span class="font-weight-400">Have a question about capacity reporting?</span>
</goab-text>

<goab-text [attr.data-testid]="'help-description'" size="body-m" tag="p">
  You’re in the right place. Whether you’re looking for quick answers,
  step-by-step guides, or need to contact support, we’re here to help you get
  back on track.
</goab-text>

<goab-divider
  [attr.data-testid]="'help-divider-before-toc'"
  mt="2xl"
  mb="2xl"
></goab-divider>

<goab-text
  [attr.data-testid]="'help-toc-title'"
  size="heading-l"
  tag="h2"
  mb="none"
>
  <span class="font-weight-400">Table of contents</span>
</goab-text>
@for (item of toc; track index; let index = $index) {
<div [ngClass]="index > 0 ? 'topic-section' : ''">
  <a [href]="'help#help-section-' + ($index + 1) + '-title'"
    ><goab-text
      [attr.data-testid]="'help-toc-item-' + $index"
      size="body-m"
      tag="p"
      mt="l"
      mb="none"
    >
      {{ index + 1 }}. {{ item }}
    </goab-text>
  </a>
</div>
}

<goab-divider
  [attr.data-testid]="'help-divider-after-toc'"
  mt="2xl"
  mb="2xl"
></goab-divider>

<goab-text
  [id]="'help-section-1-title'"
  [attr.data-testid]="'help-section-1-title'"
  size="heading-l"
  tag="h2"
  mb="l"
>
  <span class="font-weight-400">{{ sections[0].sectionDisplayTitle }}</span>
</goab-text>

<goab-text
  [attr.data-testid]="'help-section-1-content-para-1'"
  size="body-m"
  tag="p"
  mb="xs"
>
  Please review this section to help ensure your reporting is consistent, even
  if you have filled out the form many times. Your reporting helps Assisted
  Living Alberta better understand capacity across the system.
</goab-text>

@for(subsection of sections[0].sections; track sectionIndex; let sectionIndex =
$index) {
<goab-text
  [attr.data-testid]="'help-section-1-subsection-' + sectionIndex + '-title'"
  tag="h4"
  size="heading-xs"
  mb="s"
>
  {{ subsection.title }}
</goab-text>
@for(item of subsection.content; track paraIndex; let paraIndex = $index){
<goab-text
  class="mb-l"
  [attr.data-testid]="
    'help-section-1-subsection-' + sectionIndex + '-content-para-' + paraIndex
  "
  tag="p"
>
  {{ item }}
</goab-text>

} }

<goab-divider
  [attr.data-testid]="'help-divider-after-section-1'"
  mt="2xl"
  mb="2xl"
></goab-divider>

<goab-text
  [id]="'help-section-2-title'"
  [attr.data-testid]="'help-section-2-title'"
  size="heading-l"
  tag="h2"
>
  <span class="font-weight-400">{{ sections[1].title }}</span>
</goab-text>

@for(subsection of sections[1].sections; track sectionIndex; let sectionIndex =
$index) {
<goab-text
  [attr.data-testid]="'help-section-2-subsection-' + sectionIndex + '-title'"
  tag="h4"
  mb="s"
  size="heading-xs"
>
  {{ subsection.title }}
</goab-text>
@for(item of subsection.content; track paraIndex; let paraIndex = $index){
<goab-text
  [attr.data-testid]="
    'help-section-2-subsection-' + sectionIndex + '-content-para-' + paraIndex
  "
  tag="p"
  >{{ item }}
</goab-text>

} }

<goab-divider
  [attr.data-testid]="'help-divider-after-section-2'"
  mt="2xl"
  mb="2xl"
></goab-divider>

<goab-text
  [id]="'help-section-3-title'"
  [attr.data-testid]="'help-section-3-title'"
  size="heading-l"
  tag="h2"
>
  <span class="font-weight-400">{{ sections[2].title }}</span>
</goab-text>
<goab-button type="tertiary" mb="m" (onClick)="onToggleAccordion()">
  {{ accordionStatus }}
</goab-button>
<div class="faq-container">
  @for(accordion of sections[2].sections; track accordionIndex; let
  accordionIndex = $index) {
  <goab-accordion
    headingSize="medium"
    heading="{{ accordion.title }}"
    [open]="expandedList[accordionIndex]"
    (onChange)="toggleAccordion(accordionIndex, $event)"
    [attr.data-testid]="'help-section-3-accordion-' + accordionIndex + '-title'"
  >
    @for(subsection of accordion.sections; track sectionIndex; let sectionIndex
    = $index){
    <goab-text
      [attr.data-testid]="
        'help-section-3-accordion-' +
        accordionIndex +
        '-subsection-' +
        sectionIndex +
        '-title'
      "
      tag="h4"
      mt="none"
      mb="none"
      size="heading-xs"
    >
      {{ subsection.title }}
    </goab-text>

    @for(item of subsection.content; track paraIndex; let paraIndex = $index){
    <goab-text
      [attr.data-testid]="
        'help-section-3-subsection-' +
        accordionIndex +
        '-content-para-' +
        sectionIndex
      "
      tag="p"
    >
      @if (isHtmlFragment(item)) {
      <span [innerHTML]="item"></span>
      } @else {
      {{ item }}
      }
    </goab-text>
    }
    <div class="mb-l"></div>
    }
  </goab-accordion>
  }
</div>

<goab-divider
  [attr.data-testid]="'help-divider-after-section-3'"
  mt="2xl"
  mb="2xl"
></goab-divider>

<goab-text
  [id]="'help-section-4-title'"
  [attr.data-testid]="'help-section-4-title'"
  size="heading-l"
  tag="h2"
  mb="l"
>
  <span class="font-weight-400">{{ sections[3].title }}</span>
</goab-text>
<!-- <goab-text
  [attr.data-testid]="'help-section-4-content-para-1'"
  size="body-m"
  tag="p"
  mb="xs"
> -->
@for(subsection of sections[3].sections; track sectionIndex; let sectionIndex =
$index) {
<goab-text
  [attr.data-testid]="'help-section-4-subsection-' + sectionIndex + '-title'"
  tag="h4"
  mb="s"
  size="heading-xs"
>
  {{ subsection.title }}
</goab-text>
@for(item of subsection.content; track paraIndex; let paraIndex = $index){
<goab-text
  class="mb-l"
  [attr.data-testid]="
    'help-section-4-subsection-' + sectionIndex + '-content-para-' + paraIndex
  "
  tag="p"
>
  {{ item }}
</goab-text>

} }
<div class="goab-text-replacement" data-testid="help-section-3-content-para-1">
  <p class="body-m-mb-xs">
    If you need to change your response from Yes back to No, please email
    <a [attr.href]="emailHref">
      alss.alacapacity&#64;gov.ab.ca
      <goab-icon class="open-icon" type="open" [opacity]="1"></goab-icon>
    </a>
    with your facility name and reason for the change.
  </p>
</div>
<goab-text
  [attr.data-testid]="'help-section-4-subsection-4-title'"
  tag="h4"
  mb="s"
  size="heading-xs"
>
  Note
</goab-text>
<ul class="help-note-list">
  <li>
    <goab-text
      class="mb-l"
      [attr.data-testid]="'help-section-4-subsection-4-content-para-1'"
      tag="p"
      mb="xs"
    >
      If your policy changes during the week, update it in your next weekly
      report.
    </goab-text>
  </li>
  <li>
    <goab-text
      class="mb-l"
      [attr.data-testid]="'help-section-4-subsection-4-content-para-2'"
      tag="p"
      mt="none"
      mb="none"
    >
      Keep a copy of your policy handy in case it is requested for verification.
    </goab-text>
  </li>
</ul>

<goab-divider
  [attr.data-testid]="'help-divider-after-section-4'"
  mt="2xl"
  mb="2xl"
></goab-divider>

<goab-text
  [id]="'help-section-5-title'"
  [attr.data-testid]="'help-section-5-title'"
  size="heading-l"
  tag="h2"
  mb="l"
>
  <span class="font-weight-400">{{ sections[4].title }}</span>
</goab-text>
<!-- <goab-text
  [attr.data-testid]="'help-section-4-content-para-1'"
  size="body-m"
  tag="p"
  mb="xs"
> -->
<div class="goab-text-replacement" data-testid="help-section-5-content-para-1">
  <p class="body-m-mb-xs">
    If you still need help, please email
    <a [attr.href]="emailHref">
      alss.alacapacity&#64;gov.ab.ca
      <goab-icon class="open-icon" type="open" [opacity]="1"></goab-icon>
    </a>
  </p>
</div>
<!-- </goab-text> -->
<goab-text
  [attr.data-testid]="'help-section-5-content-para-2'"
  size="body-m"
  tag="p"
  mb="xs"
>
  Please include these details for faster response:
</goab-text>
<ol class="help-request-hint">
  @for(prompt of helpRequestDetailPrompts; track $index) {
  <li class="help-request-detail-prompt">
    <goab-text
      [attr.data-testid]="'help-section-5-content-para-2-prompt-' + $index"
      tag="p"
      mt="xs"
      mb="xs"
    >
      {{ prompt }}
    </goab-text>
  </li>
  }
</ol>
@for(subsection of sections[4].sections; track sectionIndex; let sectionIndex =
$index) {
<goab-text
  [attr.data-testid]="'help-section-5-subsection-' + sectionIndex + '-title'"
  size="heading-xs"
  tag="h4"
  mb="s"
>
  {{ subsection.title }}
</goab-text>
@for(item of subsection.content; track paraIndex; let paraIndex = $index){
<goab-text
  class="mb-l"
  [attr.data-testid]="
    'help-section-4-subsection-' + sectionIndex + '-content-para-' + paraIndex
  "
  tag="p"
>
  {{ item }}
</goab-text>

} }
